import { render, staticRenderFns } from "./DatatableDistributionList.vue?vue&type=template&id=26b04895"
import script from "./DatatableDistributionList.vue?vue&type=script&lang=js"
export * from "./DatatableDistributionList.vue?vue&type=script&lang=js"
import style0 from "./DatatableDistributionList.vue?vue&type=style&index=0&id=26b04895&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports